import React, { createContext, useState, useEffect, useContext } from "react";
import { getProjects, type Project as ApiProject } from "../api/projectsApi.ts";

interface Project extends ApiProject {
    category?: {
        name: string;
        entity_type: string;
    };
    similar?: any[];
    reviews?: any[];
}

interface ProjectsContextType {
    projects: Project[];
    loading: boolean;
    error: string | null;
    refresh: () => Promise<void>;
}

const ProjectsContext = createContext<ProjectsContextType>({
    projects: [],
    loading: false,
    error: null,
    refresh: async () => {},
});

export const ProjectsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [projects, setProjects] = useState<Project[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchProjects = async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await getProjects();
            setProjects(data as Project[]);
        } catch (err) {
            console.error("Ошибка при загрузке проектов:", err);
            setError("Не удалось загрузить проекты");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (projects.length === 0) fetchProjects();
    }, []);

    return (
        <ProjectsContext.Provider value={{ projects, loading, error, refresh: fetchProjects }}>
            {children}
        </ProjectsContext.Provider>
    );
};

export const useProjects = () => useContext(ProjectsContext);